/**
 * Compact IDR label used on the /data storefront: 149000 -> "Rp149rb",
 * 1500000 -> "Rp1,5jt". Derived from the product constants, never typed.
 */
export function formatIdrShort(n: number): string {
	if (n >= 1_000_000) {
		const jt = n / 1_000_000;
		return `Rp${Number.isInteger(jt) ? jt : jt.toFixed(1).replace(".", ",")}jt`;
	}
	return `Rp${Math.round(n / 1000)}rb`;
}
